/**
 * Consent Management Constants
 *
 * Shared constants for consent cookie names, values, and configuration.
 * These are used by both server-side and client-side code.
 */

// =============================================================================
// OneTrust Cookie Names
// =============================================================================

/** OneTrust consent cookie containing group consent values */
export const ONETRUST_CONSENT_COOKIE = "OptanonConsent";

/** OneTrust alert box closed cookie (indicates user has interacted with banner) */
export const ONETRUST_ALERTBOX_COOKIE = "OptanonAlertBoxClosed";

// =============================================================================
// Consent Values
// =============================================================================

/** Cookie value indicating user has consented */
export const CONSENT_VALUE_YES = "1";

/** Cookie value indicating user has NOT consented */
export const CONSENT_VALUE_NO = "0";

// =============================================================================
// OneTrust Consent Models
// =============================================================================

/** Opt-in consent model (GDPR - requires explicit consent) */
export const CONSENT_MODEL_OPT_IN = "opt-in";

/** Opt-out consent model (CCPA - consent assumed, user can opt out) */
export const CONSENT_MODEL_OPT_OUT = "opt-out";

// =============================================================================
// OneTrust SDK URLs
// =============================================================================

/** Default OneTrust SDK script URL */
export const ONETRUST_SDK_URL =
  "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";

/** OneTrust auto-block script base URL */
export const ONETRUST_AUTO_BLOCK_URL_BASE = "https://cdn.cookielaw.org/consent";
